import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FixedActions from '../components/FixedActions';
import { MapPin, Phone, Mail, Clock, Send, CheckCircle } from 'lucide-react';
import { trackContactFormSubmit, trackPhoneClick } from '../utils/analytics';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    projectType: 'sports'
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    
    // Track form submission in Google Analytics
    trackContactFormSubmit('contact_page');
    
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        projectType: 'sports'
      });
    }, 3000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const contactInfo = [
    {
      icon: <MapPin size={28} />,
      title: 'Visit Us',
      content: 'RT Nagar, Bengaluru 560032',
      subContent: 'Karnataka, India',
      action: () => window.open('https://maps.google.com/?q=RT+Nagar+Bengaluru+560032', '_blank')
    },
    {
      icon: <Phone size={28} />,
      title: 'Call Us',
      content: '+91 99646 60033',
      subContent: 'Mon - Sat: 9 AM - 6 PM',
      action: () => {
        trackPhoneClick('contact_page');
        window.open('tel:+919964660033');
      }
    },
    {
      icon: <Mail size={28} />,
      title: 'Email Us',
      content: 'rajashekar@rightshade.in',
      subContent: 'We reply within 24 hours',
      action: () => window.open('mailto:rajashekar@rightshade.in')
    }
  ];

  return (
    <div style={{ background: '#FAFBFC' }}>
      <Header />
      <FixedActions />
      
      {/* Hero Section */}
      <section style={{
        paddingTop: '140px',
        paddingBottom: '80px',
        background: 'linear-gradient(135deg, #1A1B1E 0%, #2D2E32 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23FFD700" fill-opacity="0.05"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          opacity: 0.4
        }}></div>
        
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <h1 style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              fontWeight: 700,
              color: 'white',
              marginBottom: '24px',
              fontFamily: "'Poppins', sans-serif"
            }}>
              Let's Build Something Amazing Together
            </h1>
            <p style={{
              fontSize: 'clamp(1.125rem, 2vw, 1.375rem)',
              color: 'rgba(255,255,255,0.9)',
              lineHeight: 1.6,
              fontFamily: "'Inter', sans-serif"
            }}>
              Have a sports court or construction project in mind? Get in touch with us today for a free consultation and competitive quote.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Cards */}
      <section style={{ padding: '60px 0', marginTop: '-60px', position: 'relative', zIndex: 2 }}>
        <div className="container">
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '24px',
            marginBottom: '60px'
          }}>
            {contactInfo.map((info, index) => (
              <div 
                key={index}
                onClick={info.action}
                style={{
                  background: 'white',
                  padding: '32px',
                  borderRadius: '16px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  cursor: info.action ? 'pointer' : 'default',
                  transition: 'all 0.3s ease',
                  border: '2px solid transparent',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(255,215,0,0.3)';
                  e.currentTarget.style.borderColor = '#FFD700';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = 'transparent';
                }}
              >
                <div style={{
                  width: '64px',
                  height: '64px',
                  background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  margin: '0 auto 20px'
                }}>
                  {info.icon}
                </div>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 600,
                  marginBottom: '8px',
                  color: '#1A1B1E',
                  fontFamily: "'Poppins', sans-serif"
                }}>
                  {info.title}
                </h3>
                <p style={{
                  fontSize: '16px',
                  color: '#4A5568',
                  marginBottom: '4px',
                  fontWeight: 500
                }}>
                  {info.content}
                </p>
                <p style={{
                  fontSize: '14px',
                  color: '#718096'
                }}>
                  {info.subContent}
                </p>
              </div>
            ))}
          </div>

          {/* Form and Map Section */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1.2fr 0.8fr',
            gap: '40px',
            marginTop: '60px'
          }}>
            {/* Contact Form */}
            <div style={{
              background: 'white',
              padding: '48px',
              borderRadius: '20px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
            }}>
              <h2 style={{
                fontSize: '32px',
                fontWeight: 700,
                marginBottom: '12px',
                color: '#1A1B1E',
                fontFamily: "'Poppins', sans-serif"
              }}>
                Send Us a Message
              </h2>
              <p style={{
                fontSize: '16px',
                color: '#718096',
                marginBottom: '32px',
                lineHeight: 1.6
              }}>
                Fill out the form below and our team will get back to you within 24 hours
              </p>

              {submitted ? (
                <div style={{
                  padding: '48px',
                  textAlign: 'center',
                  background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                  borderRadius: '16px',
                  color: 'white'
                }}>
                  <CheckCircle size={64} style={{ margin: '0 auto 20px' }} />
                  <h3 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '12px' }}>
                    Thank You!
                  </h3>
                  <p style={{ fontSize: '16px' }}>
                    We've received your message and will get back to you soon.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                    <div>
                      <label style={{
                        display: 'block',
                        marginBottom: '8px',
                        fontWeight: 600,
                        color: '#1A1B1E',
                        fontSize: '14px'
                      }}>
                        Full Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="John Doe"
                        style={{
                          width: '100%',
                          padding: '14px 16px',
                          border: '2px solid #E2E8F0',
                          borderRadius: '12px',
                          fontSize: '15px',
                          transition: 'all 0.3s ease',
                          fontFamily: "'Inter', sans-serif"
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#FFD700'}
                        onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                      />
                    </div>
                    <div>
                      <label style={{
                        display: 'block',
                        marginBottom: '8px',
                        fontWeight: 600,
                        color: '#1A1B1E',
                        fontSize: '14px'
                      }}>
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="+91 XXXXX XXXXX"
                        style={{
                          width: '100%',
                          padding: '14px 16px',
                          border: '2px solid #E2E8F0',
                          borderRadius: '12px',
                          fontSize: '15px',
                          transition: 'all 0.3s ease',
                          fontFamily: "'Inter', sans-serif"
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#FFD700'}
                        onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                      />
                    </div>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: 600,
                      color: '#1A1B1E',
                      fontSize: '14px'
                    }}>
                      Email Address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #E2E8F0',
                        borderRadius: '12px',
                        fontSize: '15px',
                        transition: 'all 0.3s ease',
                        fontFamily: "'Inter', sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#FFD700'}
                      onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                    />
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: 600,
                      color: '#1A1B1E',
                      fontSize: '14px'
                    }}>
                      Project Type *
                    </label>
                    <select
                      name="projectType"
                      value={formData.projectType}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #E2E8F0',
                        borderRadius: '12px',
                        fontSize: '15px',
                        background: 'white',
                        transition: 'all 0.3s ease',
                        fontFamily: "'Inter', sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#FFD700'}
                      onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                    >
                      <option value="sports">Sports Courts</option>
                      <option value="construction">Construction</option>
                      <option value="both">Sports & Construction</option>
                      <option value="consultation">Consultation Only</option>
                    </select>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: 600,
                      color: '#1A1B1E',
                      fontSize: '14px'
                    }}>
                      Subject *
                    </label>
                    <input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      placeholder="What can we help you with?"
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #E2E8F0',
                        borderRadius: '12px',
                        fontSize: '15px',
                        transition: 'all 0.3s ease',
                        fontFamily: "'Inter', sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#FFD700'}
                      onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                    />
                  </div>

                  <div style={{ marginBottom: '28px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: 600,
                      color: '#1A1B1E',
                      fontSize: '14px'
                    }}>
                      Message *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Tell us more about your project requirements..."
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #E2E8F0',
                        borderRadius: '12px',
                        fontSize: '15px',
                        resize: 'vertical',
                        transition: 'all 0.3s ease',
                        fontFamily: "'Inter', sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#FFD700'}
                      onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      width: '100%',
                      padding: '16px',
                      fontSize: '16px',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      fontFamily: "'Inter', sans-serif"
                    }}
                  >
                    Send Message <Send size={20} />
                  </button>
                </form>
              )}
            </div>

            {/* Map and Info */}
            <div>
              {/* Google Map */}
              <div style={{
                background: 'white',
                padding: '24px',
                borderRadius: '20px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                marginBottom: '24px'
              }}>
                <h3 style={{
                  fontSize: '24px',
                  fontWeight: 600,
                  marginBottom: '16px',
                  color: '#1A1B1E',
                  fontFamily: "'Poppins', sans-serif"
                }}>
                  Find Us Here
                </h3>
                <div style={{
                  width: '100%',
                  height: '300px',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.2596326!2d77.59856!3d13.02137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDAxJzE3LjAiTiA3N8KwMzUnNTQuOCJF!5e0!3m2!1sen!2sin!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Right Shade Location"
                  ></iframe>
                </div>
              </div>

              {/* Why Choose Us */}
              <div style={{
                background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                padding: '32px',
                borderRadius: '20px',
                color: 'white'
              }}>
                <h3 style={{
                  fontSize: '24px',
                  fontWeight: 600,
                  marginBottom: '20px',
                  fontFamily: "'Poppins', sans-serif"
                }}>
                  Why Choose Us?
                </h3>
                
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700
                    }}>
                      15+
                    </div>
                    <h4 style={{ fontSize: '18px', fontWeight: 600 }}>Years of Experience</h4>
                  </div>
                  <p style={{ fontSize: '14px', opacity: 0.9, marginLeft: '44px' }}>
                    Proven expertise in sports and construction
                  </p>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700,
                      fontSize: '14px'
                    }}>
                      500+
                    </div>
                    <h4 style={{ fontSize: '18px', fontWeight: 600 }}>Projects Delivered</h4>
                  </div>
                  <p style={{ fontSize: '14px', opacity: 0.9, marginLeft: '44px' }}>
                    Successfully completed across India
                  </p>
                </div>

                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700
                    }}>
                      ✓
                    </div>
                    <h4 style={{ fontSize: '18px', fontWeight: 600 }}>Quality Guaranteed</h4>
                  </div>
                  <p style={{ fontSize: '14px', opacity: 0.9, marginLeft: '44px' }}>
                    Premium materials & best practices
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        @media (max-width: 1024px) {
          section > div > div[style*="gridTemplateColumns"] {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }

        @media (max-width: 768px) {
          section {
            padding: 60px 20px !important;
          }
          
          section:first-of-type {
            padding-top: 100px !important;
            padding-bottom: 60px !important;
          }
          
          form > div[style*="gridTemplateColumns: 1fr 1fr"] {
            grid-template-columns: 1fr !important;
          }
          
          /* Contact info cards */
          section:nth-of-type(2) > div > div:first-child {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
          
          /* Form and Map sections - Make full width in mobile */
          section:nth-of-type(2) > div > div:last-child {
            grid-template-columns: 1fr !important;
          }
          
          /* Form section - Increase width */
          section:nth-of-type(2) > div > div:last-child > div:first-child {
            padding: 32px 20px !important;
            width: 100% !important;
          }
          
          /* Map section - Increase width */
          section:nth-of-type(2) > div > div:last-child > div:last-child {
            width: 100% !important;
          }
          
          /* Why choose us section */
          section:nth-of-type(3) > div > div {
            grid-template-columns: 1fr !important;
            text-align: center !important;
          }
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Contact;
